/* eslint-disable no-param-reassign */
import axios from 'axios';
import store from '../store';

/*
Change baseURL to suit your project needs.
*/
const http = axios.create({
  timeout: 5000,
});
const httpStreamMapping = axios.create({
  baseURL: process.env.VUE_APP_STREAM_MAPPING_API,
  timeout: 5000,
});

http.interceptors.request.use((config) => {
  const { device, config: gameConfig, account, terminalUserData, isNextGen } = store.getters;
  let uuid, password;
  if (account) {
    uuid = account.uuid;
    password = account.password;
  }
  const token = terminalUserData?.auth?.token ?? terminalUserData?.token;

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
    config.headers['http-x-nab-betshop-id'] = gameConfig.betshop.id;
    config.headers['http-x-nab-company-id'] = gameConfig.companyData.id;
    config.headers['http-x-nab-device-uuid'] = device.uuid;
    config.headers['http-x-nab-dp'] = 'AdminTerminal';
    config.headers['seven-locale'] = gameConfig.locale;
    config.headers['x-nsft-seven-company-uuid'] = gameConfig.companyData.uuid;
  } else if (account && uuid && password) {
    const basicAuthToken = btoa(`${uuid}:${password}`);
    config.headers['Authorization'] = `Basic ${basicAuthToken}`;
    config.headers['seven-locale'] = gameConfig.locale;
  } else if (isNextGen) {
    config.headers['X-Nsft-Ngs-Company'] = gameConfig.tenantId;
    config.headers['X-Nsft-Ngs-Product'] = gameConfig.productId;
  }
  return config;
});

export { http, httpStreamMapping };
